import { gql } from '@apollo/client';

export const RESEND_CREDENTIALS_TO_TUTOR = gql`
  mutation ResendCredentialsToTutor($input: ResendCredentialsToTutorInput!) {
    resendCredentialsToTutor(input: $input) {
      tutorId
    }
  }
`;
